import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { route } from 'src/app/app.route';

import { AppAuthService } from '../services/app-auth.service';
import { AppLogService } from '../services/app-log.service';
import { AppRouteService } from '../services/app-route.service';

@Injectable()
export class AppAuthGuard {
  private _authService = inject(AppAuthService);
  private _appRouteService = inject(AppRouteService);
  constructor() {}

  async canActivate(active: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const currentUser = await this._authService.getCurrentUser();
      if (!currentUser) throw new Error('Auth Guard: Unauthorized User');

      const mfaStatus = this._authService.isMFARequired();

      if (mfaStatus) {
        throw new Error('Auth Guard: User must configure MFA');
      }

      if (active.data.roles) {
        if (this._authService.hasAccess(active.data.roles)) {
          return true;
        } else {
          throw new Error('Auth Guard: Forbidden User');
        }
      } else {
        return true;
      }
    } catch (error) {
      AppLogService.error(error);
      this._appRouteService.navigate(`${route.home.path}`);

      return false;
    }
  }
}
